import { useIntl } from '@capsicum/common';
import { CondensedButton } from '@capsicum/common-web';
import { useFanTokenOfferingClaimButton } from '@capsicum/features/fan-token-offering/shared';
import { type FanTokenOfferingWithPartner } from '@capsicum/socios-core';
import { type ReactNode } from 'react';

import * as S from '../FanTokenOffering.styled';

/**
 * Display a Claim button
 *
 * @param {fto} props.fto the fan token offering
 * @returns {JSX.Element} a with a button and some comments
 */
export const FTOClaimButton = ({
	fto,
	hasReachedClaimEndDate,
	onClaimClick
}: {
	fto: FanTokenOfferingWithPartner;
	hasReachedClaimEndDate: boolean;
	onClaimClick: () => void;
}) => {
	const { $t } = useIntl();
	const { actionText, amountTranslationKey, amountTranslationParams, disabled, hideButton, testID } =
		useFanTokenOfferingClaimButton({ fto, hasReachedClaimEndDate });

	const onClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClaimClick();
	};

	return (
		<S.BuyContainer onClick={e => e.stopPropagation()}>
			<S.ClaimComment>
				{$t(amountTranslationKey, {
					...amountTranslationParams,
					strong: (chunks: Array<ReactNode>) => <S.Bold>{chunks}</S.Bold>
				})}
			</S.ClaimComment>
			{!hideButton && (
				<CondensedButton
					color="brand"
					debouncingTime={500}
					disabled={disabled}
					size="xsmall"
					testID={testID}
					text={actionText}
					textSize="xsmall"
					onClick={onClick}
				/>
			)}
		</S.BuyContainer>
	);
};
